import { observable, computed, action } from 'mobx';
import { ISearchFitments, IFetchedFitments } from '../../../common/interfaces/search';
import { app } from '../App';
import { search } from '.';

export class Fitments {
    @observable public fitments: IFetchedFitments[] = [];

    @computed private get fitmentItemIds(): number[] {
        return this.fitments.map((fitmentGroup) => fitmentGroup.itemId);
    }

    @action public fetchFitments = async (itemId: number, itemCode: string): Promise<ISearchFitments> => {
        try {
            let itemFound = this.fitmentItemIds.indexOf(itemId);

            if (itemFound !== -1) {
                this.fitments[itemFound].loading = this.fitments[itemFound].fitments.length > 0 ? false : true;
            } else {
                itemFound = this.fitments.length;
                this.fitments.push({
                    loading: true,
                    itemId,
                    itemCode,
                    fitments: []
                });
            }

            const service = app.service('item-fitments');
            const fitments = await service.find({ query: { itemcode: itemCode, $skip: 0, $limit: 99999 }}) as ISearchFitments;

            this.fitments[itemFound].loading = false;
            this.fitments[itemFound].fitments = fitments.data;

            console.log('fitments: ', fitments);

            return fitments;
        } catch (err) {
            console.error(err);
            return err;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Fitments.ts